import { FormControl, FormGroup, FormLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

import JsonCodeInputMonacoEditor from 'common/components/code-editor/JsonCodeInputMonacoEditor';
import SimpleCodeErrorView from 'common/components/code-editor/SimpleCodeErrorView';
import RenderFormFields from 'common/features/renderForms/RenderFormFields';
import { useState } from 'react';

const RenderFormExtraFields = (props) => {
    const { fields, handleFieldChange, name, formConfig } = props;
    const { t } = useTranslation();
    const [inputError, setInputError] = useState({ metadata: null });

    const handleValueChangeCode = (value, name, errors) => {
        const codeHaveErrors = errors && Array.isArray(errors) && errors.length > 0;
        const newErrors = codeHaveErrors ? errors : null;

        setInputError({ ...inputError, [name]: newErrors });

        handleFieldChange({
            target: {
                name,
                value,
            },
        });
    };

    return (
        <>
            {formConfig ? (
                <RenderFormFields formConfig={formConfig} fields={fields} handleFieldChange={handleFieldChange} />
            ) : (
                <FormGroup>
                    <FormLabel>{t('taxonomy.form.metadata')}</FormLabel>

                    <FormControl style={{ minHeight: '5em' }}>
                        <JsonCodeInputMonacoEditor
                            height={200}
                            name={name}
                            value={fields?.[name] || ''}
                            onChange={(value, errors) => handleValueChangeCode(value, name, errors)}
                        />
                        <SimpleCodeErrorView
                            id={'error-metadata'}
                            mainErrorMessage={t('JsonError')}
                            errorList={inputError[name]}
                        />
                    </FormControl>
                </FormGroup>
            )}
        </>
    );
};

export default RenderFormExtraFields;
